import type { ReactNode } from 'react';
import { TotpAuthGate } from '@lemontaigu/platform-ui';
import { supabase } from '../supabase.js';

/**
 * Desk gate: authenticated → TOTP (AAL2) → staff membership.
 *
 * The 250-line flow moved to @lemontaigu/platform-ui at ladder step 4 (F8);
 * what remains here is the only part that was ever app-specific — the brand,
 * the membership predicate and the refusal copy. This file is a composition
 * root: it is where the concrete `supabase` client is bound to the shared gate.
 */
async function userIsStaff(): Promise<boolean> {
  // RLS self-select exposes only the caller's own staff row, if any.
  const { data, error } = await supabase.from('staff').select('user_id').limit(1);
  if (error) return false;
  return (data?.length ?? 0) > 0;
}

export function AuthGate({ children }: { children: ReactNode }) {
  return (
    <TotpAuthGate
      client={supabase}
      brand="Réception"
      checkMembership={userIsStaff}
      deniedMessage="Ce compte n’a pas accès à l’outil de réception. Contactez l’administrateur."
    >
      {children}
    </TotpAuthGate>
  );
}
